export const FRAME_PREVIEW_SCALE = 0.4;
export const CSS_VARIABLE_HOVERED_STAGE_STROKE_WIDTH = '--frame-preview-stroke-width';